import React from 'react';
import SmallTag from './SmallTag';
import { allowMultiple } from '../../Utils/Utils';

// tiny helper: normalize multval -> array
const toArray = (v) => {
  if (Array.isArray(v)) return v;
  if (typeof v === 'string') {
    try {
      const parsed = JSON.parse(v);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
};

// shallow array equality (order-sensitive, which matches your UI)
const arrEq = (a, b) => {
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
  return true;
};

function arePropsEqual(prev, next) {
  // identity of the field
  if (prev.field?.attrName !== next.field?.attrName) return false;
  if (prev.field?.type !== next.field?.type) return false;

  // raw value (for non-multi, and for text/number/date/etc)
  if (prev.field?.value !== next.field?.value) return false;

  // zones / appearance
  if (prev.zoneType !== next.zoneType) return false;
  if (prev.nodeColor !== next.nodeColor) return false;

  // iteration / target
  if (prev.ind !== next.ind) return false;
  if (prev.objId !== next.objId) return false;

  // (optional) edit rights if you pass it as a prop
  if (prev.canWrite !== next.canWrite) return false;

  // multi-values only if the field is multi (prev OR next, just in case)
  const prevIsMulti =
    prev.objectsDefList && prev.field
      ? allowMultiple(prev.objectsDefList, prev.field.type, prev.field.attrName)
      : false;
  const nextIsMulti =
    next.objectsDefList && next.field
      ? allowMultiple(next.objectsDefList, next.field.type, next.field.attrName)
      : false;

  if (prevIsMulti || nextIsMulti) {
    const prevKey = `${prev.field.attrName}_multval`;
    const nextKey = `${next.field.attrName}_multval`;

    const prevArr = toArray(prev.node?.data?.[prevKey]);
    const nextArr = toArray(next.node?.data?.[nextKey]);

    if (!arrEq(prevArr, nextArr)) return false;
  }

  return true; // no significant prop change → skip render
}

const SmallTagMemo = React.memo(SmallTag, arePropsEqual);
SmallTagMemo.displayName = 'SmallTagMemo';
export default SmallTagMemo;
